import integracionPantallas from './IntegracionPantallas';
import maxwellIA from './MaxwellIA';

export default {
    integracionPantallas,
    maxwellIA,
};
